import { Navigate } from 'react-router-dom';
import useAuthStore from '../../stores/authStore';

/**
 * Protected Route Component
 * Redirects to login if user is not authenticated.
 * Auth is initialized once in main.jsx via bootstrapAuth().
 */
function ProtectedRoute({ children }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
